import { queryClient } from "~/plugins/vue-query";
import { checkboxService } from "~/utils/api/checkboxService";
import { getProjectId } from "~/utils/getProjectId";

export default defineNuxtRouteMiddleware(async () => {
  const projectId = getProjectId();

  if (projectId) {
    queryClient.fetchQuery({
      queryKey: ["checkboxes"],
      queryFn: () =>
        checkboxService.getCheckbox({
          client_project_id: projectId,
        }),
    });
  }
});
